import { defineMessages } from 'react-intl.macro';
import { FormattedMessage } from 'react-intl';

import './ChartDoc.scss';

import { MainContent } from '../app/components/MainContent';
import { CreatorCountTable } from './CreatorCountTable';
import { SubjektCountTable } from './SubjektCountTable';
import { ZadatelCountTable } from './ZadatelCountTable';
import { DmvsSourceChart } from './DmvsSourceChart';
import { InfoAlert } from '@tmapy/style-guide';
import { useMessage } from '@tmapy/intl';

export const msg = defineMessages<any>({
  title: {
    id: 'chart.title',
    defaultMessage: 'Analýza správy aktualizačních dat',
  },
  chartHelpText: {
    id: 'chart.helpText',
    defaultMessage:
      'Analytický nástroj, zobrazující top 10. záznamů dle různých kriterií v tabulkovém zobrazení, nebo sloupcových grafech.',
  },
});

export const ChartDoc: React.FC = () => {
  const formatMessage = useMessage();

  const chartHelpText = formatMessage(msg.chartHelpText);

  return (
    <MainContent width='full'>
      <article>
        <div className='dmx-chart--head sg-u-vs-2'>
          <div className='sg-a-d-f sg-a-g-2 sg-a-ai-b sg-a-jc-sb sg-a-fw-w'>
            <header className='sg-a-d-f sg-a-ai-b sg-a-g-1 sg-a-fw-w'>
              <h2 className='sg-u-type-h1'>
                <FormattedMessage {...msg.title} />
              </h2>
            </header>
          </div>
        </div>

        {chartHelpText && (
          <div className='sg-a-mw-fc sg-a-mb-2'>
            <InfoAlert>{chartHelpText}</InfoAlert>
          </div>
        )}
        <div className='dmx-chart--cols'>
          <CreatorCountTable />
          <DmvsSourceChart />
          <ZadatelCountTable />
          <SubjektCountTable />
        </div>
      </article>
    </MainContent>
  );
};
